// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"4469d409","453":"6165d948","977":"aac5dfd0"}[chunkId] + ".chunk.js";
};